var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM6 20V4H13V9H18V20H6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1668 16C12.9177 16 13.5239 15.33 13.5239 14.5V11.5C13.5239 10.67 12.9177 10 12.1668 10C11.4158 10 10.8096 10.67 10.8096 11.5V14.5C10.8096 15.33 11.4158 16 12.1668 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4287 14.5C14.4287 15.88 13.4153 17 12.1668 17C10.9182 17 9.90485 15.88 9.90485 14.5H9.00009C9.00009 16.265 10.1808 17.715 11.7144 17.96V19.5H12.6191V17.96C14.1527 17.715 15.3334 16.265 15.3334 14.5H14.4287Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceNote);
export default __webpack_public_path__ + "static/media/voice_note.5bf2333b75a992cf4573ece5178e4b45.svg";
export { ForwardRef as ReactComponent };